<template>
    <div class="d-flex flex-wrap justify-content-between">
        <Talk :userID="userId" class="mb-1" />
        <TalkSummary :userId="userId" :periods="periods" />
    </div>
</template>

<script>
import { Talk } from '../'
import { getParam } from '@/lib/url'
import { TalkSummary } from '@/views/components/summaries'

export default {
    components: { TalkSummary, Talk },
    computed: {
        userId() {
            return getParam('id', this)
        },
        periods() {
            return this.$store.state.filters.periods
        },
    },
}
</script>
